import React, { useEffect, useMemo } from 'react';
import { inp, lbl, noAutofill, smallBtn } from './shared';

const emptyMember = { firstName: '', lastName: '', dob: '', gender: '', tobacco: '', pregnant: '', relationship: '' };

export default function Household({ data, onChange }) {
  const members = useMemo(() => data.householdMembers || [], [data.householdMembers]);
  const shouldSeedSelf = data.coverageFor === 'Myself' || data.coverageFor === 'Myself and my family';

  useEffect(() => {
    if (!shouldSeedSelf || members.length > 0) return;
    if (!data.firstName && !data.lastName) return;
    onChange('householdMembers', [{
      ...emptyMember,
      firstName: data.firstName || '',
      lastName: data.lastName || '',
      relationship: 'Self',
      seededFromBasicInfo: true,
    }]);
  }, [shouldSeedSelf, members.length, data.firstName, data.lastName, onChange]);

  useEffect(() => {
    if (!shouldSeedSelf || members.length === 0) return;
    const first = members[0];
    if (!first.seededFromBasicInfo) return;
    if (first.firstName === data.firstName && first.lastName === data.lastName) return;
    onChange('householdMembers', members.map((member, index) => index === 0 ? {
      ...member,
      firstName: data.firstName || '',
      lastName: data.lastName || '',
      relationship: member.relationship || 'Self',
    } : member));
  }, [shouldSeedSelf, members, data.firstName, data.lastName, onChange]);

  function update(index, field, value) {
    onChange('householdMembers', members.map((member, i) => i === index ? { ...member, [field]: value, seededFromBasicInfo: false } : member));
  }

  function add() {
    onChange('householdMembers', [...members, { ...emptyMember }]);
  }

  function remove(index) {
    onChange('householdMembers', members.filter((_, i) => i !== index));
  }

  return (
    <div>
      <p style={hint}>Add each person who may need coverage. Include yourself if you are applying too.</p>
      {members.map((member, index) => (
        <div key={index} style={card}>
          <div style={cardHead}>
            <strong>Person {index + 1}</strong>
            <button type="button" style={smallBtn} onClick={() => remove(index)}>Remove</button>
          </div>
          <div style={grid3}>
            <div><label style={lbl}>First Name</label><input style={inp} value={member.firstName} onChange={e => update(index, 'firstName', e.target.value)} {...noAutofill(`member-${index}-first-name`)} /></div>
            <div><label style={lbl}>Last Name</label><input style={inp} value={member.lastName} onChange={e => update(index, 'lastName', e.target.value)} {...noAutofill(`member-${index}-last-name`)} /></div>
            <div><label style={lbl}>Date of Birth</label><input style={inp} type="date" value={member.dob} onChange={e => update(index, 'dob', e.target.value)} /></div>
            <div>
              <label style={lbl}>Gender</label>
              <select style={inp} value={member.gender} onChange={e => update(index, 'gender', e.target.value)}>
                <option value="">Select...</option>
                <option>Male</option>
                <option>Female</option>
              </select>
            </div>
            <div><label style={lbl}>Uses Tobacco?</label><select style={inp} value={member.tobacco} onChange={e => update(index, 'tobacco', e.target.value)}><option value="">Select...</option><option>Yes</option><option>No</option></select></div>
            <div><label style={lbl}>Pregnant?</label><select style={inp} value={member.pregnant} onChange={e => update(index, 'pregnant', e.target.value)}><option value="">Select...</option><option>Yes</option><option>No</option></select></div>
            <div>
              <label style={lbl}>Relationship</label>
              <select style={inp} value={member.relationship} onChange={e => update(index, 'relationship', e.target.value)}>
                <option value="">Select...</option>
                <option>Self</option>
                <option>Spouse</option>
                <option>Son</option>
                <option>Daughter</option>
              </select>
            </div>
          </div>
        </div>
      ))}
      <button type="button" style={smallBtn} onClick={add}>Add Person</button>
    </div>
  );
}

const hint = { color: '#4a6288', lineHeight: 1.5, marginTop: 0 };
const card = { border: '1.5px solid #c5d5e8', borderRadius: 8, padding: 16, marginBottom: 14, background: '#fff' };
const cardHead = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14, color: '#1a3364' };
const grid3 = { display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 14 };
